<template>
	<div class="bg-[#F5F9FA] h-screen pt-[43px] box-border">
		<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto mb-[40px] flex items-center">
			<img @click="backIndex()" src="@/static/image/icon12.png" class="w-[24px] cursor-pointer h-[24px]" alt="" />
			<label @click="backIndex() "
				class="text-[18px] cursor-pointer text-[#000000]">{{langList.login_home}}</label>
		</div>
		<div class="2xl:max-w-3xl xl:max-w-3xl mx-auto bg-white rounded-[10px] flex ">
			<!-- 登录页面 -->
			<div class="min-h-[700px] pb-[20px] box-border mx-auto flex  flex-col items-center pt-[6%] box-border">
				<div class="flex items-center justify-center mb-[40px]">
					<div @click="changeTab(0)"
						:class="tabIndex==0?'text-[#3894ff] text-[30px]':'text-[26px] text-[#000000]'"
						class="  font-bold cursor-pointer  mr-[32px]">
						{{langList.login_title}}
					</div>
					<div @click="changeTab(1)"
						:class="tabIndex==1?'text-[#3894ff] text-[30px]':'text-[26px] text-[#000000]'"
						class=" text-[#000000] cursor-pointer font-bold">
						{{langList.reg_title}}
					</div>
				</div>

				<div class="w-[520px] mx-auto ">
					<div class="" v-if="tabIndex==0">
						<div class="pr-[40px]">
							<div
								class="flex items-center justify-between mb-[16px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
								<img src="@/static/image/icon80.png" class="w-[18px] h-[18px]" alt="" />
								<input v-model="mobile_email" :placeholder="langList.enter_account_tip"
									class="text-[16px]" style="width: calc(100% - 38px);" />
							</div>
							<div
								class="flex items-center justify-between mb-[18px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
								<img src="@/static/image/icon14.png" class="w-[18px] h-[18px]" alt="" />
								<input type="password" v-model="password" :placeholder="langList.login_password_tip"
									class="text-[16px]" style="width: calc(100% - 38px);" />
							</div>
							<div @click="forgetPassword()"
								class="cursor-pointer text-[18px] font-bold text-[#3894FF] mb-[100px]">
								{{langList.login_forget}}
							</div>
						</div>
						<div @click="loginBtn()"
							class="w-[248px] h-[64px] mb-[20px] cursor-pointer  mx-auto leading-[64px] rounded-[50px] bg-[#3894FF] text-center text-white text-[18px] font-bold">
							{{langList.login_submit}}
						</div>
					</div>

					<div class="" v-else-if="tabIndex==1">
						<div class="pr-[40px]">
							<div class="mb-[30px] flex  text-[16px] text-[#101010]">
								<div @click="selectLoginMethod(1)" :class="loginMethod==1?'active':''"
									class="loginTitle  cursor-pointer relative mr-[60px]">
									{{langList.login_email}}
								</div>
								<div @click="selectLoginMethod(2)" :class="loginMethod==2?'active':''"
									class="loginTitle cursor-pointer relative mr-[60px]">
									{{langList.login_tel}}
								</div>
								<div @click="selectLoginMethod(3)" :class="loginMethod==3?'active':''"
									class="loginTitle cursor-pointer relative">
									{{langList.reg_wx}}
								</div>
							</div>
							<div v-if="loginMethod==1"
								class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
								<img src="@/static/image/icon80.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
								<input v-model="email" :placeholder="langList.login_email_tip"
									class="text-[16px] flex-1" />
							</div>
							<div v-else-if="loginMethod==2"
								class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
								<img src="@/static/image/icon13.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
								<input v-model="phone" :placeholder="langList.login_tel_tip"
									class="text-[16px] flex-1" />
							</div>
							<div v-if="loginMethod==1||loginMethod==2"
								class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
								<img src="@/static/image/icon14.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
								<input v-model="password" type="password" :placeholder="langList.login_password_tip"
									class="text-[16px] flex-1" />
							</div>
							<div v-if="loginMethod==1||loginMethod==2"
								class="flex items-center justify-between mb-[20px] bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
								<img src="@/static/image/icon14.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
								<input v-model="nextPassword" type="password" :placeholder="langList.reg_password_tip"
									class="text-[16px] flex-1" />
							</div>

							<div v-if="loginMethod==1||loginMethod==2"
								class="flex items-center justify-between mb-[20px]  bg-[#F5F9FA] py-[20px] px-[18px] box-border w-full">
								<img src="@/static/image/icon15.png" class="w-[18px] h-[18px] mr-[10px]" alt="" />
								<input v-model="code" :placeholder="langList.reg_code_tip" class="text-[16px] flex-1" />
								<div @click="getCodeClick()"
									class="min-w-[126px] px-[10px] box-border whitespace-no-wrap cursor-pointer text-[18px] text-[#3894FF] font-semibold text-right"
									style="">
									{{getCodeText}}
								</div>
							</div>
						</div>
						<div v-if="loginMethod==1" class=" mb-[24px] text-[#B8B8B8]">
							<label class="text-[#FF0000]">{{langList.reg_tip}}：</label>{{langList.reg_tip_content}}
						</div>
						<div v-else-if="loginMethod==2" class=" mb-[24px] text-[#B8B8B8]">
							<label class="text-[#FF0000]">{{langList.login_tip}}：</label>{{langList.login_tip_content}}
						</div>
						<div @click="registerBtn()" v-if="loginMethod!=3"
							class="w-[248px] h-[64px] cursor-pointer mb-[30px] mx-auto leading-[64px] rounded-[50px] bg-[#3894FF] text-center text-white text-[18px] font-bold">
							{{langList.reg_submit}}
						</div>

					</div>

					<div class="flex items-center flex-wrap">
						<img :src="isCheck?checkActive:check" @click="isCheck=!isCheck"
							class="w-[16px] h-[16px] mr-[6px] cursor-pointer" alt="" srcset="" />
						{{langList.reg_read}} <router-link :to="{path:'/agreement',query: { mark: 'UserAgreement' }}"
							class="text-[#3894FF] no-underline flex"
							target="_blank">《{{langList.reg_agree}}》</router-link>{{langList.reg_and}}<router-link
							:to="{path:'/agreement',query: { mark: 'PrivacyAgreement' }}"
							class="text-[#3894FF] no-underline" target="_blank">《{{langList.reg_hide}}》</router-link>
					</div>
				</div>
			</div>
			<!-- 登录页面 -->
		</div>

		<el-dialog :title="langList['completeInfo']" :show-close="false" :visible.sync="updateInfoVisible" width="20%">
			<span class="text-[16px]">{{langList['bind_tip']}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button v-if="!useremail" @click="updateEmail()">{{langList['Modify the email address']}}</el-button>
				<el-button v-else-if="!usermobile" @click="updateEmail()">{{langList['Modify the mobile']}}</el-button>
				<!-- <el-button type="primary" @click="updatePass()">{{langList['study_password']}}</el-button> -->
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {

				tabIndex: 0, //0登录 1 注册
				loginMethod: 1, //1邮箱 2手机号 3微信
				email: "", //邮箱
				mobile_email: "", //手机号/邮箱
				phone: '', //手机号
				password: '', //密码
				langList: {},
				isCheck: false,
				checkActive: require('../../static/image/icon17.png'),
				check: require('../../static/image/icon16.png'),
				updateInfoVisible: false,
				usermobile: '',
				useremail: '',

				nextPassword: '',
				code: '', //验证码

				getCodeText: '',
				getCodeisWaiting: false,
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				// 你可以在这里处理查询参数的变化
				console.log(to.tabIndex);
				this.tabIndex = to.query.tabIndex

			}
		},
		mounted() {
			localStorage.removeItem('userInfo')
			localStorage.removeItem('token')
			this.getdict_data()

			if (this.$route.query.tabIndex) {
				this.tabIndex = this.$route.query.tabIndex
			}

		},
		methods: {

			changeTab(type) {
				this.tabIndex = type

				if (type == 0) {
					document.title = this.langList.pc_name + '-' + this.langList.login_title
				} else if (type == 1) {
					document.title = this.langList.pc_name + '-' + this.langList.reg_title
				}

				this.loginMethod = 1
				this.email = ""
				this.mobile_email = ""
				this.phone = ""
				this.password = ""
				this.isCheck = false
				this.usermobile = ""

				this.useremail = ""
				this.nextPassword = ""
				this.code = ""

				this.getCodeText = ""
				this.getCodeisWaiting = false

				this.getCodeText = this.langList.reg_get_code
				clearInterval(this.Timer)
				this.Timer = null

			},
			// 选择登录方式
			selectLoginMethod(method) {
				this.loginMethod = method;
				this.email = "";
				this.phone = "";
				this.password = "";
				this.nextPassword = "";
				this.code = "";


				this.getCodeisWaiting = false;
				this.getCodeText = this.langList.reg_get_code
				clearInterval(this.Timer)
				this.Timer = null
			},
			// 获取验证码
			getCodeClick() {

				if (this.loginMethod == 1) {
					if (!this.email) {
						this.$message({
							message: this.langList.login_email_tip,
							type: 'warning'
						});
						return
					}
				} else if (this.loginMethod == 2) {
					if (!this.phone) {
						this.$message({
							message: this.langList.login_tel_tip,
							type: 'warning'
						});
						return
					}
				}

				if (this.getCodeisWaiting) {
					return
				}
				this.getCodeText = this.langList.sending //发送验证码
				this.getCodeisWaiting = true;

				this.getCode()
			},
			getCodeTimer() {
				let holdTime = 60; //定义变量并赋值
				// this.getCodeText = "重新获取60s"
				this.Timer = setInterval(() => {
					if (holdTime <= 0) {
						this.getCodeisWaiting = false;
						this.getCodeText = this.langList.reg_get_code
						clearInterval(this.Timer); //清除该函数
						return; //返回前面
					}
					this.getCodeText = this.langList.re_obtain + holdTime + "s"
					holdTime--;
				}, 1000)
			},

			getCode() {

				if (this.loginMethod == 1) {
					this.$api.sendResetPasswordCode({
						email: this.email,
						type: 'register'
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'success'
						})
						this.getCodeTimer()
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				} else if (this.loginMethod == 2) {
					this.$api.send({
						phone: this.phone,
						user_register: 'user_register'
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'success'
						})
						this.getCodeTimer()
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				}


			},

			// 立即注册
			registerBtn() {
				if (!this.isCheck) {
					this.$message({
						message: this.langList.login_agree_tip,
						type: 'warning'
					});
					return
				}
				if (this.loginMethod == 1) {
					this.emailRegister() //邮箱注册
				} else if (this.loginMethod == 2) {
					this.phoneRegister() //手机号注册
				}
			},
			phoneRegister() {
				if (!this.phone) {
					this.$message({
						message: this.langList.login_tel_tip,
						type: 'warning'
					});
					return
				}
				const reg = /^1[3456789]\d{9}$/;
				if (!reg.test(this.phone)) {
					this.$message({
						message: this.langList.wrong_phone_number,
						type: 'warning'
					});
					return
				}

				if (!this.password) {
					this.$message({
						message: this.langList.login_password_tip,
						type: 'warning'
					});
					return
				}
				if (!this.nextPassword) {
					this.$message({
						message: this.langList.reg_password_tip,
						type: 'warning'
					});
					return
				}
				if (this.password != this.nextPassword) {
					this.$message({
						message: this.langList.entered_passwords_differ,
						type: 'warning'
					});
					return
				}
				if (!this.code) {
					this.$message({
						message: this.langList.reg_code_tip,
						type: 'warning'
					});
					return
				}

				this.$api.register({
					mobile: this.phone,
					password: this.password,
					type: 2,
					code: this.code
				}).then((res) => {

					this.$message({
						message: this.langList.registered_successfully,
						type: 'success'
					});

					this.$api.login({
						mobile: this.phone,
						password: this.password,
						type: 2,
					}).then((res) => {
						console.log(res);
						localStorage.setItem('token', res.data.token)
						setTimeout(() => {
							const redirectUrl = localStorage.getItem('loginRedirect');
							if (redirectUrl) {
								localStorage.removeItem('loginRedirect'); // 删除记录
								this.$router.push(redirectUrl);
							} else {

								this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径

								// this.$router.push('/'); // 使用完整路径
							}
						}, 800)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			emailRegister() {
				if (!this.email) {
					this.$message({
						message: this.langList.login_email_tip,
						type: 'warning'
					});
					return
				}
				if (!this.password) {
					this.$message({
						message: this.langList.login_password_tip,
						type: 'warning'
					});
					return
				}
				if (!this.nextPassword) {
					this.$message({
						message: this.langList.reg_password_tip,
						type: 'warning'
					});
					return
				}
				if (this.password != this.nextPassword) {
					this.$message({
						message: this.langList.entered_passwords_differ,
						type: 'warning'
					});
					return
				}
				if (!this.code) {
					this.$message({
						message: this.langList.reg_code_tip,
						type: 'warning'
					});
					return
				}

				this.$api.register({
					email: this.email,
					type: 1,
					password: this.password,
					code: this.code
				}).then((res) => {
					console.log(res);
					this.$message({
						message: this.langList.registered_successfully,
						type: 'success'
					});

					this.$api.login({
						email: this.email,
						password: this.password,
						type: 1,
					}).then((res) => {
						console.log(res);
						localStorage.setItem('token', res.data.token)
						setTimeout(() => {
							const redirectUrl = localStorage.getItem('loginRedirect');
							if (redirectUrl) {
								localStorage.removeItem('loginRedirect'); // 删除记录
								this.$router.push(redirectUrl);
							} else {
								this.$router.push(
									'/studyCenter/study/videosCourse?type=0'); // 使用完整路径
								// this.$router.push('/'); // 使用完整路径
							}
						}, 800)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langList = obj
					document.title = this.langList.pc_name + '-' + this.langList.login_title

					console.log(this.langList);
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},

			backIndex() {
				this.$router.replace({ path: '/' })
			},
			// 去注册
			goRegister() {
				this.$router.push({ path: '/register' })
			},
			// 忘记密码
			forgetPassword() {
				this.$router.push({ path: '/forgetPassword' })
			},
			updateEmail() {
				this.$router.replace({
					path: '/personalCenter/personalSet/baseInfo?type=0&is_edit=1',

				})
			},
			updatePass() {
				this.$router.replace({
					path: '/personalCenter/updatePass',

				})
			},

			// 登录
			loginBtn() {


				if (!this.isCheck) {
					this.$message({
						message: this.langList.login_agree_tip,
						type: 'warning'
					});
					return
				}
				// 账号登录 不需要选择手机号或者邮箱

				if (!this.mobile_email) {
					this.$message({
						message: this.langList.enter_account_tip,
						type: 'warning'
					});
					return
				}

				if (!this.password) {
					this.$message({
						message: this.langList.login_password_tip,
						type: 'warning'
					});
					return
				}

				this.accountLogin()
				return

				if (this.loginMethod == 1) {
					if (!this.email) {
						this.$message({
							message: this.langList.login_email_tip,
							type: 'warning'
						});
						return
					}


					if (!this.password) {
						this.$message({
							message: this.langList.login_password_tip,
							type: 'warning'
						});
						return
					}
					this.emailLogin()
				} else if (this.loginMethod == 2) {
					if (!this.phone) {
						this.$message({
							message: this.langList.login_tel_tip,
							type: 'warning'
						});
						return
					}

					const reg = /^1[3456789]\d{9}$/;
					if (!reg.test(this.phone)) {
						this.$message({
							message: '请设置正确手机号',
							type: 'warning'
						});
						return
					}
					if (!this.password) {
						this.$message({
							message: this.langList.login_password_tip,
							type: 'warning'
						});
						return
					}
					this.phoneLogin()
				}
			},
			accountLogin() {
				this.$api.login_e_p({
					mobile_email: this.mobile_email,
					password: this.password,
					user_token_expire: 0
				}).then((res) => {
					console.log(res);

					localStorage.setItem('token', res.data.token)

					// && res.data.user_info.is_background_addition == 1
					
					if (res.data.user_info.is_edit == 1 && !res.data.user_info.email) {
						this.updateInfoVisible = true
						this.usermobile = res.data.user_info.mobile
						this.useremail = res.data.user_info.email
						return
					} 
					
					// else if (res.data.user_info.is_edit == 1 && res.data.user_info.is_edit_password == '0') {
						
					// 	this.$message({
					// 		message: this.langList.study_password,
					// 		type: 'warning'
					// 	});
						
					// 	setTimeout(()=>{
					// 		this.$router.push('/personalCenter/updatePass'); // 使用完整路径
					// 	},800)
						
					// 	return
					// }
					
					this.$message({
						message: this.langList.login_succeeded,
						type: 'success'
					});

					setTimeout(() => {
						const redirectUrl = localStorage.getItem('loginRedirect');
						if (redirectUrl) {
							localStorage.removeItem('loginRedirect'); // 删除记录
							this.$router.push(redirectUrl);
						} else {
							this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
						}

					}, 800)
				}).catch((error) => {

					if (error.code == 301) {
						this.$confirm(this.langList.user_token_expire, this.langList.reg_tip, {
							confirmButtonText: this.langList.confirm_login,
							cancelButtonText: this.langList.cancel,
							type: 'info'
						}).then((ms) => {
							console.log(ms);
							if (ms == "confirm") {
								this.$api.login_e_p({
									mobile_email: this.mobile_email,
									password: this.password,
									user_token_expire: 1
								}).then((res) => {
									console.log(res);

									localStorage.setItem('token', res.data.token)
									// && res.data.user_info.is_background_addition == 1

									if (res.data.user_info.is_edit == 1 && !res.data.user_info.email) {
										this.updateInfoVisible = true
										this.usermobile = res.data.user_info.mobile
										this.useremail = res.data.user_info.email
										return
									} 
									
									// else if (res.data.user_info.is_edit == 1 && res.data.user_info.is_edit_password == '0') {
									// 	this.$message({
									// 		message: this.langList.study_password,
									// 		type: 'warning'
									// 	});
										
									// 	setTimeout(()=>{
									// 		this.$router.push('/personalCenter/updatePass'); // 使用完整路径
									// 	},800)
										
									// 	return
									// }


									this.$message({
										message: this.langList.login_succeeded,
										type: 'success'
									});
									setTimeout(() => {
										const redirectUrl = localStorage.getItem(
											'loginRedirect');
										if (redirectUrl) {
											localStorage.removeItem(
												'loginRedirect'); // 删除记录
											this.$router.push(redirectUrl);
										} else {
											this.$router.push(
												'/studyCenter/newStudyCenter'); // 使用完整路径
										}

									}, 800)
								}).catch((error) => {

									this.$message({
										message: error.msg,
										type: 'warning'
									})
								})
							}
						}).catch(() => {});

					} else {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					}
				})
			},

			phoneLogin() {
				this.$api.login({
					mobile: this.phone,
					password: this.password,
					type: 2,
				}).then((res) => {
					console.log(res);
					this.$message({
						message: this.langList.login_succeeded,
						type: 'success'
					});
					localStorage.setItem('token', res.data.token)
					setTimeout(() => {
						this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
					}, 800)
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			emailLogin() {
				this.$api.login({
					email: this.email,
					password: this.password,
					type: 1,
				}).then((res) => {
					console.log(res);
					this.$message({
						message: this.langList.login_succeeded,
						type: 'success'
					});
					localStorage.setItem('token', res.data.token)

					setTimeout(() => {
						this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
					}, 800)
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			}
		}
	}
</script>

<style scoped>
	.leftContent {
		background: linear-gradient(137.58deg, rgba(56, 148, 255, 1) -0.52%, rgba(56, 148, 255, 0.6) 112.81%);
	}

	.loginTitle.active::after {
		content: "";
		position: absolute;
		width: 42px;
		height: 8px;
		background-color: rgba(41, 121, 255, 1);
		bottom: -12px;
		left: 50%;
		transform: translateX(-50%);

	}

	input {
		border: none;
		background-color: transparent;
	}

	input:focus {
		outline: none;
	}

	input::placeholder {
		color: #CCCCCC;
		/* 例如，设置为灰色 */
	}
</style>